export function log(error: unknown) {
  // eslint-disable-next-line no-console
  console.info('error logging service', error);
}
